import "./BackToTop.css";
import { useEffect, useRef } from "react";

const BackToTop = () => {
    const backToTopRef = useRef(null);
    useEffect(() => {
        const btn = backToTopRef.current;

        if (!btn) return;

        const handleScroll = () => {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                btn.style.display = "flex";
            } else {
                btn.style.display = "none";
            }
        };

        const handleClick = () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        };

        window.addEventListener("scroll", handleScroll);
        btn.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            btn.removeEventListener("click", handleClick);
        };
    }, []);

    return (
        <button id="backToTop" title="Go to top" ref={backToTopRef}>
            <span className="arrow"></span>
        </button>
    )
}

export default BackToTop;